module.exports = __webpack_public_path__ + "img/home.a96ab1a5.png";